import { type FC } from 'react';
import { Anchor, Stack, Text } from '@mantine/core';
import Zoom from 'react-medium-image-zoom';
import { mimeTypes } from '~/shared/constants/mimeTypes';
import styles from './Check.module.css';
import 'react-medium-image-zoom/dist/styles.css';

interface OrderCheck {
    createdAt?: string;
    data?: string;
    extension?: string;
}

interface CheckProps {
    check: OrderCheck;
}

export const Check: FC<CheckProps> = ({ check }) => {
    const extension = check.extension?.toLowerCase();
    const mimeType = (extension && mimeTypes[extension as keyof typeof mimeTypes]) ?? 'application/octet-stream';
    const rawData = check.data?.trim();

    if (!rawData) {
        return <Text c='dimmed'>Чек недоступен</Text>;
    }

    const src = rawData.startsWith('data:') ? rawData : `data:${mimeType};base64,${rawData}`;

    const isImage = mimeType.startsWith('image/');
    const isPdf = mimeType === mimeTypes.pdf;
    const isUnsupportedFile = !isImage && !isPdf;

    const fileName = extension ? `check.${extension}` : 'check';
    const createdAt = check.createdAt ? new Date(check.createdAt).toLocaleString() : undefined;
    const title = createdAt ? `Чек ${createdAt}` : 'Чек';

    return (
        <Stack
            align='flex-start'
            gap={4}
        >
            {isImage && (
                <Zoom>
                    <img
                        className={styles.image}
                        src={src}
                        alt={title}
                    />
                </Zoom>
            )}

            {isPdf && (
                <object
                    aria-label={title}
                    className={styles.pdf}
                    data={src}
                    type={mimeType}
                >
                    <Text size='sm'>
                        Не удалось отобразить PDF.{' '}
                        <Anchor
                            href={src}
                            download={fileName}
                        >
                            Скачать чек
                        </Anchor>
                    </Text>
                </object>
            )}

            {isUnsupportedFile && (
                <Anchor
                    href={src}
                    download={fileName}
                >
                    Скачать чек
                </Anchor>
            )}

            {createdAt && (
                <Text
                    c='dimmed'
                    size='sm'
                >
                    {createdAt}
                </Text>
            )}
        </Stack>
    );
};
